import React from "react";
import "./Pill.css";

/**
 * Design-system Pill — rounded label / interactive prompt chip
 * (question suggestions, "Site name" footer, message bubbles base).
 *
 * @param {boolean} interactive  renders a <button> with hover state
 * @param {boolean} subtle       gray background (bg-subtle)
 * @param {"sm"|"md"} size
 */
const Pill = React.forwardRef(function Pill(
  { interactive = false, subtle = false, size = "md", className = "", children, ...rest },
  ref,
) {
  const classes = [
    "kc-pill",
    subtle ? "kc-pill--subtle" : "",
    interactive ? "kc-pill--interactive" : "",
    size === "sm" ? "kc-pill--small" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (interactive) {
    return (
      <button ref={ref} type="button" className={classes} {...rest}>
        {children}
      </button>
    );
  }
  return (
    <span ref={ref} className={classes} {...rest}>
      {children}
    </span>
  );
});

export default Pill;
